import { useMemo } from 'react';
import BigNumber from 'bignumber.js';
import { Address } from 'viem';

import { useConnection } from 'modules/auth/hooks/useConnection';
import { ONE, ZERO } from 'modules/common/const';
import { useGetLiquidStakingTokenQuery } from 'modules/liquidStaking/actions/getLiquidStakingToken';
import { useGetPoolAPYs } from 'modules/pool/hooks/useGetPoolAPYs';

interface IUseGetLiquidStakingAPY {
  apy: BigNumber;
  isLoading: boolean;
}

export function useGetLiquidStakingAPY(
  liquidStakingPoolAddress?: Address,
): IUseGetLiquidStakingAPY {
  const { cacheTime } = useConnection();
  const { poolAPYs, isLoading: isPoolAPYLoading } = useGetPoolAPYs();
  const { data: stakeTokenData, isLoading: isStakeTokenDataLoading } =
    useGetLiquidStakingTokenQuery(
      { poolAddress: liquidStakingPoolAddress },
      { refetchOnMountOrArgChange: cacheTime },
    );

  const apy = useMemo(() => {
    if (!stakeTokenData || !poolAPYs) {
      return ZERO;
    }
    const APY = poolAPYs[stakeTokenData.poolAddress];
    if (!APY) {
      return ZERO;
    }

    const { fee } = stakeTokenData;

    return ONE.minus(fee).multipliedBy(APY);
  }, [poolAPYs, stakeTokenData]);

  return {
    apy,
    isLoading: isPoolAPYLoading || isStakeTokenDataLoading,
  };
}
